import React from "react";
import { Lock } from "lucide-react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

/**
 * Wrap content that requires an approved user. Shows a lock message otherwise.
 */
export default function LockedGate({ children, feature = "This section" }) {
  const { user } = useAuth();
  const approved = user && (user.role === "admin" || user.status === "approved");

  if (approved) return children;

  return (
    <div className="rounded-2xl border border-slate-200 bg-slate-50 p-10 md:p-14 text-left" data-testid="locked-gate">
      <div className="flex items-start gap-5">
        <div className="w-14 h-14 rounded-xl bg-white border border-slate-200 grid place-items-center">
          <Lock size={22} className="text-[#00b4ff]" />
        </div>
        <div className="max-w-xl">
          <div className="text-[10px] tracking-[0.28em] uppercase font-mono-plex text-slate-500">Locked</div>
          <h2 className="mt-2 font-display text-2xl sm:text-3xl font-bold tracking-tight">
            {feature} akan unlock selepas anda Register.
          </h2>
          <p className="mt-3 text-slate-600 leading-relaxed">
            Sila lengkapkan registration LOYAL PRIMUS di <Link to="/" className="text-[#00b4ff] font-semibold hover:underline">Home</Link>,
            deposit minimum $50, dan submit Client ID untuk verification. Anda akan dinotify di Announcements once approve.
          </p>
          {user && user.status === "pending" && (
            <div className="mt-5 inline-flex items-center gap-2 text-xs font-mono-plex tracking-widest uppercase bg-white border border-slate-200 px-3 py-1.5 rounded-md">
              <span className="live-dot" /> Waiting for admin verification
            </div>
          )}
          {!user && (
            <div className="mt-6">
              <Link to="/login" className="inline-flex items-center gap-2 bg-slate-900 hover:bg-slate-800 text-white px-5 py-2.5 rounded-full text-sm font-semibold transition-colors" data-testid="locked-login-cta">
                Log in
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
